import React from "react"
import mount from "core/mount"
import { getCSRFToken } from "react-rb/request"
import Button from "@kit/design/button"
import Icon from "@kit/design/icon"

function getSwitchUserPaths() {
  const el = document.querySelector("[data-switch-user-path]")
  return {
    // Path to POST the admin switch user request. It differs depending on whether we're on the admin subdomain or the app subdomain.
    switchUserPath: el.dataset.switchUserPath,
    // URL to send a GET request (browser navigation) and show a confirmation page to switch user.
    switchUserConfirmUrl: el.dataset.switchUserConfirmUrl
  }
}

export function switchToUser(userId) {
  const { switchUserPath } = getSwitchUserPaths()
  const form = document.createElement("form")
  form.method = "POST"
  form.action = switchUserPath

  const csrfToken = getCSRFToken()
  if (csrfToken) {
    const tokenInput = document.createElement("input")
    tokenInput.type = "hidden"
    tokenInput.name = "authenticity_token"
    tokenInput.value = csrfToken
    form.appendChild(tokenInput)
  }

  const scopeInput = document.createElement("input")
  scopeInput.type = "hidden"
  scopeInput.name = "scope_identifier"
  scopeInput.value = `user_${userId}`
  form.appendChild(scopeInput)

  document.body.appendChild(form)
  form.submit()
}

export function switchToUserUrl(userId) {
  const { switchUserPath } = getSwitchUserPaths()
  return fetch(`${switchUserPath}.json`, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": getCSRFToken()
    },
    body: JSON.stringify({ scope_identifier: `user_${userId}` })
  })
    .then(response => response.json())
    .then(({ url }) => url)
}

export function SwitchUserButton({ userId, className }) {
  const handleClick = async e => {
    // Let right-click and middle-click go to the href naturally
    if (e.button !== 0) return

    e.preventDefault()
    if (e.metaKey || e.ctrlKey) {
      const newTab = window.open("", "_blank")
      const url = await switchToUserUrl(userId)
      newTab.location = url
    } else {
      switchToUser(userId)
    }
  }

  const { switchUserConfirmUrl } = getSwitchUserPaths()

  return (
    <Button
      is="plain"
      size="sm"
      className={`!h-auto !p-0 ${className || ""}`}
      href={`${switchUserConfirmUrl}?scope_identifier=user_${userId}`}
      onClick={handleClick}
      title="Switch to this user"
    >
      <Icon name="rules" size="sm" />
    </Button>
  )
}

mount({ SwitchUserButton })
